import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const LicenseInfo = ({ asset }) => {
  const [licenseId, setLicenseId] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [serviceDate, setServiceDate] = useState("");
  const [warrantyDate, setWarrantyDate] = useState("");
  const [licenses, setLicenses] = useState([]);

  // Load initial values
  useEffect(() => {
    if (asset) {
      setLicenseId(asset.licence_id || "");
      setExpiryDate(asset.license_expiry_on || "");
      setServiceDate(asset.service_date || "");
      setWarrantyDate(asset.warranty_end_date || "");
      setLicenses(asset.all_licences || []);
    }
  }, [asset]);

  // SAVE LICENSE INFORMATION
  const handleSave = async (e) => {
    e.preventDefault(); // IMPORTANT

    try {
      const selectedLicense =
        licenses.find((l) => l.licence_id == licenseId) || {};

      const payload = {
        asset_id: asset.assets_id,

        // New values
        licence_id: licenseId,
        licence_date: expiryDate,
        service_date: serviceDate,
        warranty_end_date: warrantyDate,

        // OLD VALUES — for logs
        old_licenseID: asset.licence_id,
        old_licenseExp: asset.license_expiry_on,
        old_serviceDate: asset.service_date,
        old_warrentyDate: asset.warranty_end_date,

        // NEW VALUE for logs
        new_licenseID: selectedLicense.licence_id,
      };

      await axios.post(`${API_BASE_URL}/asset/license-info`, payload);

      toast.success("License information updated!", {
        position: "bottom-right",
      });
    } catch (error) {
      console.error(error);
      toast.error("Update failed!", { position: "bottom-right" });
    }
  };

  return (
    <div className="card p-3">
      <h5 className="mb-3">License Information</h5>

      {/* FORM START */}
      <form onSubmit={handleSave}>
        <div className="row">

          {/* License Dropdown */}
          <div className="col-md-4 mb-3">
            <label className="form-label">License</label>
            <Select
              value={licenses.find((l) => l.licence_id == licenseId) || null}
              onChange={(selected) => setLicenseId(selected.licence_id)}
              options={licenses}
              getOptionLabel={(l) => l.licence_title}
              getOptionValue={(l) => l.licence_id}
              placeholder="Select License"
              isSearchable
            />
          </div>

          {/* Expiry Date */}
          <div className="col-md-4 mb-3">
            <label className="form-label">License Expiry</label>
            <input
              type="date"
              className="form-control"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
            />
          </div>

          {/* Service Date */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Service Date</label>
            <input
              type="date"
              className="form-control"
              value={serviceDate}
              onChange={(e) => setServiceDate(e.target.value)}
            />
          </div>

          {/* Warranty End Date */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Warranty End Date</label>
            <input
              type="date"
              className="form-control"
              value={warrantyDate}
              onChange={(e) => setWarrantyDate(e.target.value)}
            />
          </div>

        </div>

        {/* Submit button */}
        <button className="btn btn-primary btn-sm mt-2" type="submit">
          Save
        </button>

      </form>
      {/* FORM END */} 
    </div>
  );
};

export default LicenseInfo;
